var ReactRedux = require("react-redux");
var cookie = require('react-cookie');
var bindActionCreators = require("redux").bindActionCreators;
var MessageCreateActions = require('../../../modules/message-center/actions/message-create');
var TagsActions = require('../../../modules/tags/actions/tags');
var TargetsActions = require('../../../modules/targets/actions/targets');
var MessageCreate = require('../components/message-create.jsx');

MessageCreate.fetchData = function(query, params, store, history) {
    return store.dispatch(MessageCreateActions.fetchMessage(params.id, cookie.load('mgih_at')));
}

var mapStateToProps = function(state){
    return {
    	auth: state.auth,
        message: state.message,
        tags: state.tags.data.tags || [],
        targets: state.targets.data.targets || []
    };
}

var mapDispatchToProps = function(dispatch) {
    return bindActionCreators(Object.assign({}, MessageCreateActions, TagsActions, TargetsActions), dispatch);
}

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(MessageCreate);



// WEBPACK FOOTER //
// ./src/common/routes/message-center/containers/message-create.jsx